export const SET_USERS = 'users/SET_USERS'
export const UPDATE_USER = 'users/UPDATE_USER'